/**
 * Packages API — endpoint path builders (Package Suppliers backend).
 */

const API_BASE = process.env.RAZZLE_API_PACKAGE_PROVIDERS?.replace(/\/$/, '') ?? '';

export function packageOriginsUrl(): string {
  return `${API_BASE}/package/origins`;
}

export function packageDestinationsUrl(originId: string): string {
  return `${API_BASE}/package/destinations?originId=${encodeURIComponent(originId)}`;
}

export function packageAvailableDatesUrl(originId: string, destinationId: string): string {
  return (
    `${API_BASE}/package/closest-package` +
    `?originId=${encodeURIComponent(originId)}` +
    `&destinationId=${encodeURIComponent(destinationId)}`
  );
}
